var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "form-group",
      class: { "has-error": _vm.errors.has(_vm.name) },
    },
    [
      _vm.labelText
        ? _c(
            "label",
            {
              class: [
                _vm.isHorizontal ? _vm.labelColumnsClass : "",
                "control-label",
              ],
              attrs: { for: _vm.inputId },
            },
            [_vm._v("\n        " + _vm._s(_vm.labelText) + "\n    ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { class: _vm.isHorizontal ? _vm.inputColumnsClass : "" },
        [
          _vm.isTextarea
            ? [
                _c("textarea", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: _vm.rules,
                      expression: "rules",
                    },
                  ],
                  ref: "input",
                  staticClass: "form-control",
                  class: _vm.inputClass,
                  attrs: {
                    disabled: _vm.disabled,
                    autocomplete: _vm.autocomplete,
                    id: _vm.inputId,
                    name: _vm.name,
                    placeholder: _vm.placeholder,
                    "data-vv-as": _vm.fieldFormattedName,
                  },
                  domProps: { value: _vm.value },
                  on: {
                    input: function ($event) {
                      return _vm.updateValue($event.target.value)
                    },
                  },
                }),
              ]
            : [
                _c("input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: _vm.rules,
                      expression: "rules",
                    },
                  ],
                  ref: "input",
                  staticClass: "form-control",
                  class: _vm.inputClass,
                  attrs: {
                    disabled: _vm.disabled,
                    autocomplete: _vm.autocomplete,
                    id: _vm.inputId,
                    type: _vm.type,
                    name: _vm.name,
                    placeholder: _vm.placeholder,
                    "data-vv-as": _vm.fieldFormattedName,
                  },
                  domProps: { value: _vm.value },
                  on: {
                    input: function ($event) {
                      return _vm.updateValue($event.target.value)
                    },
                  },
                }),
              ],
          _vm._v(" "),
          _vm.errors.has(_vm.name)
            ? _c("span", { staticClass: "form-text text-danger" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.errors.first(_vm.name)) +
                    "\n        "
                ),
              ])
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }